import { z } from 'zod';
import { genderSchema } from '../const/genderSchema';
import { slugBaseSchema } from '../const/slugBaseSchema';
import { uuidSchema } from '../const/uuidSchema';

export const categoryInputSchema = z.object({
    id: uuidSchema.optional(),
    name: z
        .string({ required_error: 'укажите название категории', invalid_type_error: 'название должно быть строкой' })
        .trim()
        .min(1, 'введите название категории')
        .max(300, 'название не должно превышать 300 символов'),
    gender: genderSchema,
    shoes: z.boolean({ invalid_type_error: 'значение должно быть true/false' }).default(false),

    adminOnly: z.boolean({ invalid_type_error: 'значение должно быть true/false' }).default(false),

    baseSlug: slugBaseSchema,

    parentId: uuidSchema.optional().nullable(),
    imageId: uuidSchema.optional().nullable(),
});

export type CategoryInputSchema = z.infer<typeof categoryInputSchema>;
